export default __webpack_public_path__ + "static/media/logo-hex.8949c07a.png";